export default {
  user: {
    icon: require("@/assets/i/white/icon-usuario.svg"),
    iconHover: require("@/assets/i/gray/icon-usuario.svg"),
    titleEs: "Usuarios",
    titleEn: "Users",
    children: [
      {
        titleEs: "Usuarios de centro",
        titleEn: "Location users",
        to: "/admin/visualizers/locations"
      },
      {
        titleEs: "Agregar nuevo usuario de centro",
        titleEn: "Add new location user",
        to: "/admin/visualizers/add"
      }
    ]
  },
  devices: {
    icon: require("@/assets/i/white/icon-dispositivos.svg"),
    iconHover: require("@/assets/i/gray/icon-dispositivos.svg"),
    titleEs: "Dispositivos",
    titleEn: "Devices",
    children: [
      {
        titleEs: "Dispositivos",
        titleEn: "Devices",
        to: "/admin/devices"
      },
      {
        titleEs: "Agregar nuevo dispositivo",
        titleEn: "Add new device",
        to: "/admin/devices/add"
      }
    ]
  },
  printers: {
    icon: require("@/assets/i/icon-printer-w.svg"),
    iconHover: require("@/assets/i/icon-printer.svg"),
    titleEs: "Impresoras",
    titleEn: "Printers",
    children: [
      {
        titleEs: "Impresoras",
        titleEn: "Printers",
        to: "/printer/all"
      },
      {
        titleEs: "Orden de impresión",
        titleEn: "Print Order",
        to: "/printer/orders"
      },
      {
        titleEs: "Agregar nueva impresora",
        titleEn: "Add new printer",
        to: "/printer/add"
      }
    ]
  },
  centers: {
    icon: require("@/assets/i/white/icon-centros.svg"),
    iconHover: require("@/assets/i/gray/icon-centros.svg"),
    titleEs: "Centros",
    titleEn: "Centers",
    children: [
      {
        titleEs: "Lista de centros de distribución",
        titleEn: "Distribution center list",
        to: "/admin/locations/"
      },
      {
        titleEs: "Agregar nuevo centro de distribución",
        titleEn: "Add new distribution center",
        to: "/admin/locations/add"
      }
    ]
  }
};
